module.exports = "/_next/static/images/columbus-oh-e8958ee73920078d37908bba7099a160.jpg";